import React, { useState, useEffect } from 'react';
import './styles.scss';
import info from './../../images/i-ico.svg'
import infoWhite from './../../images/i-ico-white.svg'
import ModalMessage from '../modal-message/ModalMessage';

const ChooseContract = ( props ) => {
    let [ activeModal, setActiveModal ] = useState(false);
    let [ activeModal2, setActiveModal2 ] = useState(false);

    return (
        <>
        <div className="choose-contract">
            <div className="wrap">     
                { props.showModern  && 
                    <div className={"bar " + (props.active === 2 ? 'active': '') + (!props.showTraditional ? ' onlyOld': '')} onClick={ () => props.setContract('nowoczesny')} >
                        {/* Nowoczesny */}
                        Najem Flexrent
                        { props.active === 1 && props.showTraditional &&
                            <img src={ info } alt="informacja" onClick={ () => setActiveModal2( true )} />
                        }
                        { props.active === 2 && props.showTraditional  &&
                            <img src={ infoWhite } alt="informacja" onClick={ () => setActiveModal2( true )} />
                        }
                        { !props.showTraditional  && 
                            <img src={ infoWhite } alt="informacja" onClick={ () => setActiveModal2( true )} />
                        }
                    </div>
                }
                { props.showTraditional  &&
                    <div className={"bar " + (props.active === 1 ? 'active ': '')  + (!props.showModern ? ' onlyOld': '')} onClick={ () => props.setContract('tradycyjny')}>
                        Leasing Tradycyjny
                        { props.active === 2 && props.showModern  &&
                            <img src={ info } alt="informacja" onClick={ () => setActiveModal( true )} />
                        }
                        { props.active === 1 && props.showModern  &&
                            <img src={ infoWhite } alt="informacja" onClick={ () => setActiveModal( true )} />
                        }
                        { !props.showModern  && 
                            <img src={ infoWhite } alt="informacja" onClick={ () => setActiveModal( true )} />
                        }
                    </div>
                }  
            </div>
        </div>
        { activeModal &&  
            <ModalMessage closeModal={ () => setActiveModal(false) } 
                          button={ false } 
                          tipHeader="Leasing Tradycyjny"
                          tipText="Klasyczny leasing operacyjny w ujęciu podatkowym. Klient po zakończeniu umowy ma zagwarantowane prawo nabycia przedmiotu leasingu za wartość ustaloną na początku umowy, tzw. wartość końcową. <br />W GRENKE występują 2 rodzaje umów Leasingu Tradycyjnego - z opcją nabycia oraz obowiązkiem nabycia. Rodzaj umowy leasingu (z opcją nabycia/z obowiązkiem nabycia) jest wskazywany wraz z decyzją leasingową." />
        }
        { activeModal2 && 
            <ModalMessage closeModal={ () => setActiveModal2(false) } 
                          button={ false } 
                          tipHeader="Najem Flexrent"
                          tipText="To najlepszy sposób korzystania ze sprzętu, bez konieczności posiadania go na własność. Klient użytkuje przedmiot płacąc miesięczne/kwartalne raty. Na koniec umowy Klient zwraca sprzęt do GRENKE lub ma możliwość wymiany go na sprzęt nowszej generacji, w ramach nowej umowy, lub wykupuje go na własność." />
        }
        </>
    )
}

export default ChooseContract;